var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgvazio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    viewBox: "0 0 99 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H99V83H10C4.47715 83 0 78.5228 0 73V10Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3663 37.1887C45.9037 37.1887 47.9607 35.1317 47.9607 32.5943C47.9607 30.057 45.9037 28 43.3663 28C40.829 28 38.772 30.057 38.772 32.5943C38.772 35.1317 40.829 37.1887 43.3663 37.1887ZM19 54.3534L34.1777 39.1757L42.1357 47.1338L57.3134 31.9561L79.7108 54.3534H19Z",
    fill: "#A5A5A5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgvazio);
export default __webpack_public_path__ + "static/media/imgvazio.2785a60984f11703105451f6963e470f.svg";
export { ForwardRef as ReactComponent };